import { useTranslation } from "next-i18next";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";
import Accordion, {
  AccordionItem,
} from "@sellernote/ui/src/sds-v2/components/Accordion";
import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";

import CommonStyled from "../index.styles";
import Styled from "./index.styles";

export default function LandingSectionFaq({
  data,
  backgroundColor = COLOR.wh,
}: {
  data: AccordionItem[];
  backgroundColor?: string;
}) {
  const { t } = useTranslation(["components"]);

  const { isMobile } = useCheckIsMobile();

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  const items = data.map((item) => ({
    ...item,
    className: `fade-up-animation ${isActivatedTarget ? "active" : ""}`,
  }));

  return (
    <Styled.sectionFaq ref={target} backgroundColor={backgroundColor}>
      <Styled.container>
        <CommonStyled.sectionTitle
          className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
        >
          {t("components:landing.자주하는_질문")}
        </CommonStyled.sectionTitle>

        <Styled.accordionWrapper count={items.length}>
          <Accordion items={items} width={isMobile ? undefined : "892px"} />
        </Styled.accordionWrapper>
      </Styled.container>
    </Styled.sectionFaq>
  );
}
